import { Typography } from "@mui/material"

/**
 * One conditional skill rule the selection would override, in the selection bar's list.
 */
export function SelectionRuleItem({ rule }) {
    const label = rule.siteBased ? `${rule.name} (site-based)` : rule.name

    return (
        <Typography component="li" variant="caption" color="text.secondary">
            {label}
        </Typography>
    )
}
